import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
// 设置文件
import setting from '@/setting.js';
export default {
  namespaced: true,
  state: {
    // 顶栏菜单
    header: [],
    // 侧栏菜单
    aside: [],
    // 侧边栏收缩
    asideCollapse: setting.menu.asideCollapse,
    // 侧边栏折叠动画
    asideTransition: setting.menu.asideTransition
  },
  actions: {
    /**
     * 设置侧边栏展开或者收缩
     * @param {Object} context
     * @param {Boolean} collapse is collapse
     */
    asideCollapseSet: function asideCollapseSet(_ref, collapse) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var state, dispatch;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              state = _ref.state, dispatch = _ref.dispatch;
              // store 赋值
              state.asideCollapse = collapse;
              // 持久化
              _context.n = 1;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'menu.asideCollapse',
                value: state.asideCollapse,
                user: true
              }, {
                root: true
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * 切换侧边栏展开和收缩
     * @param {Object} context
     */
    asideCollapseToggle: function asideCollapseToggle(_ref2) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var state, dispatch;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              state = _ref2.state, dispatch = _ref2.dispatch;
              // store 赋值
              state.asideCollapse = !state.asideCollapse;
              // 持久化
              _context2.n = 1;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'menu.asideCollapse',
                value: state.asideCollapse,
                user: true
              }, {
                root: true
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    /**
     * 设置侧边栏折叠动画
     * @param {Object} context
     * @param {Boolean} transition is transition
     */
    asideTransitionSet: function asideTransitionSet(_ref3, transition) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var state, dispatch;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              state = _ref3.state, dispatch = _ref3.dispatch;
              // store 赋值
              state.asideTransition = transition;
              // 持久化
              _context3.n = 1;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'menu.asideTransition',
                value: state.asideTransition,
                user: true
              }, {
                root: true
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    /**
     * 切换侧边栏折叠动画
     * @param {Object} context
     */
    asideTransitionToggle: function asideTransitionToggle(_ref4) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var state, dispatch;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              state = _ref4.state, dispatch = _ref4.dispatch;
              // store 赋值
              state.asideTransition = !state.asideTransition;
              // 持久化
              _context4.n = 1;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'menu.asideTransition',
                value: state.asideTransition,
                user: true
              }, {
                root: true
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    /**
     * 持久化数据加载侧边栏设置
     * @param {Object} context
     */
    asideLoad: function asideLoad(_ref5) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var state, dispatch, menu;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              state = _ref5.state, dispatch = _ref5.dispatch;
              _context5.n = 1;
              return dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'menu',
                defaultValue: setting.menu,
                user: true
              }, {
                root: true
              });
            case 1:
              menu = _context5.v;
              state.asideCollapse = menu.asideCollapse !== undefined ? menu.asideCollapse : setting.menu.asideCollapse;
              state.asideTransition = menu.asideTransition !== undefined ? menu.asideTransition : setting.menu.asideTransition;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  },
  mutations: {
    /**
     * @description 设置顶栏菜单
     * @param {Object} state state
     * @param {Array} menu menu setting
     */
    headerSet: function headerSet(state, menu) {
      // store 赋值
      state.header = menu;
    },
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state state
     * @param {Array} menu menu setting
     */
    asideSet: function asideSet(state, menu) {
      // store 赋值
      state.aside = menu;
    }
  }
};